import { useInfiniteScroll } from 'ahooks';
import { useEffect, useState } from 'react';
import {
  addCategoryService,
  delSubjectService,
  deleteCategoryService,
  publishSubjectService,
  queryCategoryService,
} from './services';

export default function PortalMgrModel() {
  const [selectedCategory, setSelectedCategory] = useState<any>(null);

  const {
    data = { list: [] },
    loading,
    loadingMore,
    loadMore,
    noMore,
    reload,
  } = useInfiniteScroll(
    (d) =>
      queryCategoryService({
        pageIndex: d?.pageIndex || 0,
        pageCount: 10,
      }),
    {
      isNoMore: (d) => !(d && d.list.length >= d.pageCount * d.pageIndex),
      manual: true,
    },
  );

  const addCategory = async (data: any) => {
    await addCategoryService(data);
    reload();
  };

  const delCategory = async (data: any) => {
    await deleteCategoryService(data);
    reload();
  };

  const deleteSubject = async (data: any) => {
    await delSubjectService(data);
  };

  const publishSubject = async (data: any) => {
    await publishSubjectService(data);
  };

  useEffect(() => {
    if (data.list?.length) {
      setSelectedCategory(data.list[0].faqCatgId);
    } else {
      setSelectedCategory(null);
    }
  }, [data.list]);

  return {
    categoryList: data.list,
    loading,
    loadingMore,
    loadMore,
    noMore,
    reload,
    selectedCategory,
    setSelectedCategory,
    deleteSubject,
    publishSubject,
    addCategory,
    delCategory,
  };
}
